
<div class="container-fluid">
    <app-page-header header="{{pageTitle}}"
    [showBreadcrumb]="true"
  [breadcrumb]="breadcrumb">
    </app-page-header>

    <div class="release-main-container" id="audit-trails">
        
        <div class="release-toolbar-row">
            <p class="release-title">
                Release Name: {{ releaseTitle }}
            </p>
            <button mat-icon-button class="refresh-btn" (click)="refreshTable()" [disabled]="isRefreshing" matTooltip="Click to view the latest status">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
        <!-- for agGrid height: 625px;  -->
        <ag-grid-angular #agGrid [style]="styleChipDiv" [rowData]="filteredRowData" [columnDefs]="columnDefs"
        [infiniteInitialRowCount]="infiniteInitialRowCount"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
            class="ag-theme-material" [defaultColDef]="defaultColDef"
            [suppressMenuHide]="false" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>
</div>